import React, { useEffect, useState } from "react";
import "../../../assets/UFC_DC_V3/scss/modules/custom.scss";
import "../../../assets/UFC_DC_V3/scss/modules/anim.scss";
import Footer from '../../Includes/Layouts/UFC_DC_V2/Footer';
import FormUFC_DC_V3 from "../../Forms/FormUFC_DC_V3";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FbViewPixel from "../../../Utility/FbViewPixel";

const UFC_DC_V3 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="UFC_DC_V3" />
      <FbViewPixel />
      <div className='UFC_DC_V3'>
        <FormUFC_DC_V3 />
        <Footer />
      </div>
    </>
  )
}

export default UFC_DC_V3;